module.exports = __webpack_public_path__ + "static/media/series-poster-mobile.f09aa45c.jpg";